import { render, staticRenderFns } from "./AddReportButton.vue?vue&type=template&id=643880a4&"
import script from "./AddReportButton.vue?vue&type=script&lang=ts&"
export * from "./AddReportButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports